import React from "react";
import {
  Box,
  IconButton,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";

interface SearchMenuProps {
  value?: string;
  onSearch?: (value: string) => void;
}

export default function SearchMenu({
  value = "",
  onSearch,
}: SearchMenuProps) {

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onSearch?.(event.target.value);
  };

  const handleClear = () => {
    onSearch?.("");
  };

  return (
    <Box
      sx={{
        width: "100%",
        position: "relative",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "12px",
        backgroundColor: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 0.5,
        py:1,
        my:1
      }}
    >
      {/* Input */}
      <input
        autoFocus
        value={value}
        onChange={handleChange}
        placeholder="جستجو"
        style={{
          width: "100%",
          border: "none",
          outline: "none",
          background: "transparent",
          fontSize: "13px",
          padding: "7px 6px",
          color: "inherit",
        }}
      />

      {/* Actions */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        {value && (
          <IconButton
            size="small"
            onClick={handleClear}
            sx={{
              p: "3px",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}

        <IconButton
          size="small"
          sx={{
            p: "4px",
          }}
        >
          <SearchIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}